// ** Next Import
import { Link } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import {Stack} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const LinkStyled = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main
}))

const FooterContent = () => {
  // ** Var
  //const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        <Stack spacing={2}>
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <EmailIcon fontSize={'small'}/>
                <Typography>comercial@fogaba.com</Typography>
            </Stack>
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <PhoneIcon fontSize={'small'}/>
                <Typography>Escribinos por WhatsApp al (011) 7620-9206 y marcá la opción D</Typography>
            </Stack>
        </Stack>
      <Typography sx={{ mr: 2 }}>
        {`© ${new Date().getFullYear()}, Hecho por `}
        <LinkStyled target='_blank' to='#'>
          ItapTec
        </LinkStyled>
      </Typography>
        <div></div>
      {/*
        {hidden ? null : (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', '& :not(:last-child)': { mr: 4 } }}>
            <LinkStyled target='_blank' href='https://themeselection.com/license/'>
              License
            </LinkStyled>
            <LinkStyled target='_blank' href='https://themeselection.com/'>
              More Themes
            </LinkStyled>
            <LinkStyled
              target='_blank'
              href='https://demos.themeselection.com/materio-mui-react-nextjs-admin-template/documentation'
            >
              Documentation
            </LinkStyled>
            <LinkStyled target='_blank' href='https://themeselection.com/support/'>
              Support
            </LinkStyled>
          </Box>
        )}
      */}
    </Box>
  )
}

export default FooterContent
